import { render, staticRenderFns } from "./pleasedel.vue?vue&type=template&id=49ffd938&scoped=true&"
import script from "./pleasedel.vue?vue&type=script&lang=js&"
export * from "./pleasedel.vue?vue&type=script&lang=js&"
import style0 from "./pleasedel.vue?vue&type=style&index=0&lang=css&"
import style1 from "./pleasedel.vue?vue&type=style&index=1&id=49ffd938&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ffd938",
  null
  
)

export default component.exports